import * as runtime from '@/api/runtime'
import {
  OutputReminderMailRequest,
  OutputReminderMailRequestToJSON,
  ReminderMail,
  ReminderMailFromJSON,
  SearchReminderMailRequest,
  SearchReminderMailRequestFromJSON,
  SearchReminderMailRequestToJSON,
  SendReminderMailRequest,
  SendReminderMailRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'
import { ReminderMailBatchType } from '@/utils'

export class BatchReminderMailApi extends runtime.BaseAPI {
  async getInitialSearchCondition(): Promise<SearchReminderMailRequest> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      { batch_type: ReminderMailBatchType }
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      SearchReminderMailRequestFromJSON(JSON.parse(jsonValue))
    ).value()
  }

  async searchReminderMail(
    request: SearchReminderMailRequest
  ): Promise<ReminderMail[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(SearchReminderMailRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      `/batch/reminder/reminder-mail-search`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReminderMailFromJSON)
    ).value()
  }

  async outputReminderMail(
    request: OutputReminderMailRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/reminder/reminder-mail-list-output`,
      OutputReminderMailRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async sendReminderMail(request: SendReminderMailRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reminder/reminder-mail-send`,
      SendReminderMailRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
